/* ==========================================================
   BOTÃO CUSTOM "COMPRAR AHORA" (substitui o PayPal/dynamic checkout)
   - Esconde o accelerated checkout do Shopify (PayPal, etc)
   - Injeta um botão preto que adiciona ao carrinho e vai pra /cart
   - O Yampi intercepta /cart e leva pro checkout dele
   ========================================================== */
(function () {
  'use strict';

  var BTN_ID = 'bs-custom-buy-now';
  var BTN_LABEL = 'COMPRAR AHORA';
  var BTN_LABEL_LOADING = 'Procesando...';
  var REDIRECT_TO = '/cart'; // Yampi intercepta /cart

  function findVariantId() {
    var input = document.getElementById('bsVariantId');
    if (input && input.value) return input.value;
    // Fallback: procura input hidden name="id" do form de produto
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var hid = form.querySelector('input[name="id"]');
      if (hid && hid.value) return hid.value;
    }
    return null;
  }

  function findQuantity() {
    var qty = document.getElementById('bsQtyValue');
    if (qty && qty.value) {
      var n = parseInt(qty.value, 10);
      if (n > 0) return n;
    }
    return 1;
  }

  function addToCartAndRedirect(btn) {
    var variantId = findVariantId();
    if (!variantId) {
      alert('Por favor selecciona una variante.');
      return;
    }
    var quantity = findQuantity();
    var originalLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = BTN_LABEL_LOADING;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    })
    .then(function () {
      window.location.href = REDIRECT_TO;
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = originalLabel;
      alert('Hubo un error. Por favor inténtalo de nuevo.');
    });
  }

  function injectButton() {
    // Só mexe em página de produto
    var path = window.location.pathname;
    if (!/\/products\//.test(path)) return;

    if (document.getElementById(BTN_ID)) return; // já injetado

    // Encontra o wrapper do buy now (ou o accelerated checkout container)
    var wrapper = document.querySelector('.bs-buy-now-wrapper');
    if (!wrapper) {
      // fallback: usa o container do accelerated checkout do Horizon
      wrapper = document.querySelector('.accelerated-checkout-block');
    }
    if (!wrapper) {
      // fallback final: usa o parent do shopify-payment-button
      var spb = document.querySelector('.shopify-payment-button');
      if (spb) wrapper = spb.parentElement;
    }
    if (!wrapper) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = BTN_ID;
    btn.className = 'bs-custom-buy-now';
    btn.textContent = BTN_LABEL;
    btn.addEventListener('click', function () { addToCartAndRedirect(btn); });

    // Insere no início do wrapper (acima do PayPal escondido)
    wrapper.insertBefore(btn, wrapper.firstChild);
  }

  function run() { try { injectButton(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  [200, 800, 2000, 4000].forEach(function (ms) { setTimeout(run, ms); });

  var observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
